var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConsultationIcon = function SvgConsultationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E0F6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6854 45.6409L67.9819 43.6267C69.7012 42.8214 71.774 43.5129 72.6097 45.1751C72.8251 45.6071 72.9448 46.0764 72.9558 46.5564C72.9853 47.7333 73 48.9209 73 50.112C73 51.3511 72.9834 52.5796 72.9521 53.8009C72.9043 55.648 71.3156 57.1076 69.4048 57.0613C68.9373 57.0507 68.4752 56.9476 68.05 56.7591L63.8437 54.9031C62.6932 54.3947 61.9219 53.3156 61.839 52.0942L61.8298 51.9484C61.747 50.7253 61.7507 49.5004 61.839 48.2791C61.9219 47.1431 62.6269 46.1369 63.6872 45.6409H63.6854Z",
    fill: "#52CB94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6482 34C41.1887 34 37.7313 34.24 34.2739 34.728C31.2471 35.152 29 37.692 29 40.688V58.5159C29 61.1479 30.745 63.4759 33.3085 64.262C37.0884 65.4199 40.8682 66 44.6482 66C48.426 66 52.2059 65.422 55.9857 64.262C58.5491 63.4759 60.2942 61.1479 60.2942 58.5159V40.688C60.2942 37.692 58.0471 35.152 55.0224 34.728C51.5629 34.242 48.1055 34 44.6482 34ZM54.5913 42C54.5913 43.4727 53.355 44.6667 51.83 44.6667C50.3051 44.6667 49.0688 43.4727 49.0688 42C49.0688 40.5272 50.3051 39.3333 51.83 39.3333C53.355 39.3333 54.5913 40.5272 54.5913 42Z",
    fill: "#52CB94"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConsultationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "consultation-icon.a2e2b118a1f29f88f4adfd62bf572292.svg";